var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PasswordLogin"},[_c('v-form',{attrs:{"conponentsList":_vm.conponentsList,"rule":_vm.configList},model:{value:(_vm.fapi),callback:function ($$v) {_vm.fapi=$$v},expression:"fapi"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }